import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { devtools, persist } from 'zustand/middleware';

import { BasicLogger } from '@initia-digital/ts-utils';
import { STUDY_AREAS, STUDY_PROGRESS } from '@initia-digital/data-service-mapping';

import { IInitiaConnectContact } from '@initia-digital/types/contacts';


export const DEFAULT_CREATE_CONTACT_STATE: IInitiaConnectContact = {
    id: '',
    name: '',
    email: '',
    phone: '',
    studyArea: STUDY_AREAS.CIVIL_ENGINEERING,
    otherStudyAreaDescription: '',
    studyProgress: STUDY_PROGRESS.UNDERGRAD_3PLUS,
    otherStudyProgressDescription: '',
    comments: ''
}

export interface IState {
    logger: BasicLogger
    updateLogger: (logger: BasicLogger) => void
    isSideDrawerOpen: boolean
    setIsSideDrawerOpen: (isSideDrawerOpen: boolean) => void
    editContactState: IInitiaConnectContact
    resetEditContactState: () => void
    updateEditContactState: (updatedContact: IInitiaConnectContact) => void

}


export const useStore = create<IState>()(
    devtools(
        persist(
            immer(
                (set) => ({
                    logger: new BasicLogger({ logLevel: import.meta.env.VITE_ENV_LOWER === 'prod' ? 0 : 2, logFormat: 'BROWSER' }),
                    updateLogger: (logger: BasicLogger) => set({ logger }),
                    isSideDrawerOpen: false,
                    setIsSideDrawerOpen: (isSideDrawerOpen: boolean) => set({ isSideDrawerOpen }),
                    editContactState: DEFAULT_CREATE_CONTACT_STATE,
                    resetEditContactState: () => set({ editContactState: { ...DEFAULT_CREATE_CONTACT_STATE } }),
                    updateEditContactState: (updatedContact: IInitiaConnectContact) => set(state => {
                        // ---------------------
                        state.editContactState = updatedContact;
                    }),
                })
            ),
            {
                name: 'contact-store',
                partialize: state => ({
                    editContactState: state.editContactState
                })
            }
        )
    )
);